import type { ReactNode } from "react";
import { Alert as MantineAlert } from "@mantine/core";

/*
 * A form-wide inline message (auth failure, save error, info/success banner) —
 * backed by Mantine's `Alert`. The `tone` vocabulary maps onto Mantine palette
 * colors so the whole app keeps one semantic for status messaging.
 */

export type AlertTone = "error" | "info" | "warning" | "success";

const ALERT_COLOR: Record<AlertTone, string> = {
  error: "red",
  warning: "yellow",
  success: "green",
  info: "blue",
};

export function Alert({
  tone = "error",
  children,
}: {
  tone?: AlertTone;
  children: ReactNode;
}) {
  return (
    <MantineAlert color={ALERT_COLOR[tone]} variant="light" role="alert">
      {children}
    </MantineAlert>
  );
}
